import React from 'react';
import { graphql } from 'gatsby';
import get from 'lodash/get';
import { getImage } from 'gatsby-plugin-image';
import {
  Text, Picture
} from '@comicrelief/component-library';

import {
  Wrapper, Container, Header, Image
} from './Person.styles';
import Layout from '../../components/Layout/Layout';
import { SEO, SEO_PAGE_TYPES } from '../../components/SEO/SEO';
import renderRichText from '../../components/RichText/RichText';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';

const Person = (props) => {
  const person = get(props, 'data.allContentfulPagePerson.edges[0].node');
  const {
    title, image, body, role
  } = person;

  const thisImageData = getImage(image);
  const thisImageFallback = thisImageData?.images?.fallback?.src;
  const thisImageSrcSet = thisImageData?.images?.fallback?.srcSet
                     || thisImageData?.images?.sources?.[0]?.srcSet;
  const thisImageLow = thisImageData?.placeholder?.fallback;
  const thisImageDesc = image?.description ?? '';

  // As ALL Persons are 'children' of the 'people' page, we hardcode this,
  // rather than using a per-person field set in the CMS:
  const parentPages = [
    { title: 'About Us', path: 'about' },
    { title: 'Careers', path: 'careers' },
    { title: 'Meet The Team', path: 'meet-the-team' }
  ];

  return (
    <Layout>
      <Wrapper>

        <Breadcrumb thisPageTitle={title} parentPages={parentPages} />

        <Header>
          <Text tag="h1">
            {title}
          </Text>
          <Text tag="p">
            {role}
          </Text>
        </Header>
        <Container>
          {image ? (
            <Image>
              <Picture
                alt={thisImageDesc}
                image={thisImageFallback}
                images={thisImageSrcSet}
                imageLow={thisImageLow}
              />
            </Image>
          ) : null}
          {renderRichText(body, 'white')}
        </Container>
      </Wrapper>
    </Layout>
  );
};

export default Person;

export const Head = props => (
  <SEO
    allData={props}
    pageType={SEO_PAGE_TYPES.PERSON}
    listAsArticle
  />
);

export const pageQuery = graphql`
  query getPerson($slug: String) {
    allContentfulPagePerson(filter: { path: { eq: $slug } }) {
      edges {
        node {
          title
          role
          path
          summary {
            summary
          }
          body {
            raw
          }
          image {
            ...Picture__Person
          }
        }
      }
    }
  }
`;
